module.exports = __webpack_public_path__ + "img/2_143.9ed9a7d7.png";